import { NEPAL } from 'constants/countries';
import { useCurrentUser } from 'hooks/query/useUserInfo';

export const useCountryCheck = (country = NEPAL): boolean => {
  const user = useCurrentUser();
  return user?.country === country;
};
